import moment from 'moment';
import React, { Component } from 'react';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';

/**
 * Ofrece información útil acerca de una solicitud de horas extra, incluyendo los fichajes realizados en la jornada correspondiente.
 * Props:
 * - id: Id de la solicitud de horas extra.
 * - action: Acción que se va a realizar sobre la solicitud.
 */
export default class InfoHorasExtra extends Component {

    constructor(props) {
        super(props);
        this.state = {
            horasExtra: null,
            fichajes: null
        };
    }

    componentDidMount() {
        this.updateData();
    }

    async updateData() {
        const overtime = await apiGet("horasextras/get/" + this.props.id);
        this.setState({ horasExtra: overtime });
        if (overtime) {
            const formData = new FormData();
            formData.append("trabajador", overtime.trabajador);
            formData.append("desde", moment(overtime.fecha).startOf('day').format("YYYY-MM-DD HH:mm"));
            formData.append("hasta", moment(overtime.fecha).endOf('day').format("YYYY-MM-DD HH:mm"));
            this.setState({ fichajes: await apiForm("fichajes/table", formData) });
        }
    }

    render() {
        if (this.state.horasExtra && this.state.fichajes) {
            let i = 0;
            const content = this.state.fichajes.map((fichaje, index) => {
                i++;
                return (
                    <span key={index} index={index}>
                        {moment.utc(fichaje.FechaHora).local().format("HH:mm")}
                        {i % 2 == 0 ? <br /> : " - "}
                    </span>
                );
            });
            return <>
                {this.props.action && `Confirma para ${this.props.action.toLowerCase()} las horas extra.`}
                {this.state.fichajes.length > 0 && this.state.fichajes.length % 2 == 0 ? <>
                    <br />
                    Día {moment(this.state.horasExtra.fecha).format("DD/MM/YY")},
                    de {this.state.horasExtra.horaInicioStr} a {this.state.horasExtra.horaFinStr}.
                    <h5>Fichajes del día:</h5>
                    {content}
                </> : ""}
            </>;
        }
        return <Loading />;
    }
}
